
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MatBottomSheet } from '@angular/material';

@Component({
  selector: 'app-title-page',
  templateUrl: './title-page.component.html',
  styleUrls: ['./title-page.component.scss']
})
export class TitlePageComponent implements OnInit {

  public title;
  constructor(
    public titleService: Title,
    public router: Router,
    public activatedRout: ActivatedRoute
    ) {}

    ngOnInit(): void {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.title = this.getTitle(this.router.routerState, this.router.routerState.root).join('-');
          this.titleService.setTitle(this.title);
        }
      });

    }

    getTitle(state, parent) {
      const data = [];
      if (parent && parent.snapshot.data && parent.snapshot.data.title) {
        data.push(parent.snapshot.data.title);
      }

      if (state && parent) {
        data.push(... this.getTitle(state, state.firstChild(parent)));
      }
      return data;
    }

}
